$(function () {
    var windowHeight = $(window).height();
    $('.content-wrapper').css('min-height', windowHeight - $('.site-footer').outerHeight() - $('.navbar').outerHeight() - 22);
});